import React from "react";
import classes from "./TextInput.module.css";

const TextInput = (props) => {
  const { type, placeholder, value, onChange, inputStyle, disabled } = props;

  return (
    <div className={classes.container}>
      <label className={classes.label}>{placeholder}</label>
      <input type={type} value={value} onChange={event => onChange(event.target.value)} className={inputStyle} disabled={disabled} />
    </div>
  );
};

export default TextInput;